module.exports = __webpack_public_path__ + "static/beauty-285a0f1af68ad6306e4158913a8eaeb6.png";